module.exports = __webpack_public_path__ + "static/img/plsch5.f0499b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plsch5.png
// module id = 0H7H
// module chunks = 0